export default (betKey) => {
  const splitKey = betKey.split(':')
  switch (true) {
    case splitKey[0] === 'ANY':
      return 'full_dice'

    case splitKey[1] === 'MATCH':
    case splitKey[1] === 'TRIPLE':
    case splitKey[2] === 'COMBI' && splitKey[0] === splitKey[1]:
      return splitKey[0]

    case splitKey[2] === 'COMBI':
      return `[${splitKey[0]}, ${splitKey[1]}]`

    default:
      return splitKey[2]
  }
}
